var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41",
    "data-name": "Group 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.615,
    height: 64.391,
    viewBox: "0 0 67.615 64.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3514",
    "data-name": "Rectangle 3514",
    width: 67.615,
    height: 64.391,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M56.1,57.771l2.338,4.671a3.036,3.036,0,0,0,5.668,0l2.338-4.671a12.7,12.7,0,0,0,1.166-4.947V4.226A4.227,4.227,0,0,0,63.389,0H59.163a4.227,4.227,0,0,0-4.226,4.226H52.824A4.227,4.227,0,0,0,48.6,8.452V16.9a2.113,2.113,0,1,0,4.226,0V8.452h2.113V52.824A12.7,12.7,0,0,0,56.1,57.771m3.06-53.545h4.226v48.6a8.748,8.748,0,0,1-.721,3.06l-1.392,2.779-1.392-2.779a8.748,8.748,0,0,1-.721-3.06ZM4.226,63.389H42.259a4.227,4.227,0,0,0,4.226-4.226V16.9a7.893,7.893,0,0,0-2.113-5.1l-9.69-9.69A7.914,7.914,0,0,0,29.582,0H4.226A4.227,4.227,0,0,0,0,4.226V59.163a4.227,4.227,0,0,0,4.226,4.226M39.272,12.678H33.808V7.214ZM4.226,4.226H29.582v8.452A4.227,4.227,0,0,0,33.808,16.9h8.452V59.163H4.226Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M8.113,11.726H19.734a2.113,2.113,0,1,0,0-4.226H8.113a2.113,2.113,0,1,0,0,4.226m25.356,6.339H8.113a2.113,2.113,0,1,0,0,4.226H33.469a2.113,2.113,0,1,0,0-4.226m0,8.452H8.113a2.113,2.113,0,1,0,0,4.226H33.469a2.113,2.113,0,1,0,0-4.226m0,8.452H8.113a2.113,2.113,0,1,0,0,4.226H33.469a2.113,2.113,0,1,0,0-4.226m0,8.452H8.113a2.113,2.113,0,1,0,0,4.226H33.469a2.113,2.113,0,1,0,0-4.226",
    transform: "translate(2.452 3.065)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessingIcon);
export default __webpack_public_path__ + "static/media/processing-icon.c654fa90d3964d577a06f265a5da4bbe.svg";
export { ForwardRef as ReactComponent };